import { createFileRoute } from "@tanstack/react-router";
import { DEFAULT_COMPANY, isCompanyId } from "../prototype/fixtures";
import { NewInvoiceScreen } from "../screens/InvoicesScreen";

export const Route = createFileRoute("/prototype/c/$companyId/sales/invoices/new")({
  component: NewInvoice,
});

function NewInvoice() {
  const { companyId } = Route.useParams();
  return <NewInvoiceScreen companyId={isCompanyId(companyId) ? companyId : DEFAULT_COMPANY} />;
}
